import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { DateBox, NumberBox, TextArea, TextBox } from '../../shared/controls/form';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import SelectBox from '../../shared/controls/form/selectBox';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import { dropdownPayload } from '../../shared/constants';

const validationSchemaDeal = Yup.object().shape({
  name: Yup.string().required('Opportunity Name is required'),
  stageId: Yup.string().required('Stage is required'),

  industryId: Yup.string().required('Industry is required'),

  leadSourceId: Yup.string().required('Lead Source is required'),

  sourceName: Yup.string().required('Source Name is required'),

  nextStep: Yup.string().required('Next Step is required'),

  city: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(50, 'City cannot exceed 50 characters.')
    .test('valid-characters', 'Please enter valid city', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s'-.]+$/.test(value);
    }),

  state: Yup.string()
    .nullable()
    .test('is-alphabet-only', 'State should only contain alphabets', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s]+$/.test(value); // Only alphabets if not blank
    }),

  country: Yup.string()
    .nullable()
    .trim()
    .test('valid-country', 'Country should only contain alphabets and hyphens', (value) => {
      if (!value) return true; // Allow blank input
      // Allow alphabets, spaces and single hyphens
      return (
        /^[A-Za-z\s-]+$/.test(value) && // Only alphabets, spaces and hyphens
        !/--/.test(value) && // No consecutive hyphens
        !/^-|-$/.test(value)
      ); // No leading/trailing hyphens
    }),

  zipCode: Yup.string()
    .nullable()
    .trim()
    .test(
      'is-valid-zip-code',
      'ZIP code must be 3-10 characters with only letters, numbers and hyphens',
      (value) => {
        if (!value) return true; // Allow empty value

        // Check for valid characters and length
        return (
          /^[A-Za-z0-9-]{3,10}$/.test(value) && // Only letters, numbers, hyphen
          !/--/.test(value)
        ); // No consecutive hyphens
      }
    ),

  businessType: Yup.string().nullable(),
  lineOfBusiness: Yup.string().nullable(),
});

const ConvertLead = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const owner = useSelector(getActiveOwners);
  const stage = useSelector(getGenericMasterFilteredListByKey('Stage'));

  // Campaign dropdown
  const {
    options: campaignSource,
    isLoading: isCampaignLoading,
    handleSearch: handleCampaignSearch,
    handleScroll: handleCampaignScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getCampaignDropdown,
    responseKey: 'campaignList',
  });

  const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));

  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));

  const [formData, setFormData] = useState();
  console.log('🚀 ~ formData:', formData);
  const [errormsg, setErrorMsg] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [contactExist, setContactExist] = useState(false);
  const [accountExist, setAccountExist] = useState(false);
  const [isCheckBox, setIsCheckBox] = useState(false);
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  const [editedDescription, setEditedDescription] = useState(location.state?.description || '');
  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'timeZone'
  );
  const [loading, setLoading] = useState(storeLoading);
  const [attachmentModule, setAttachmentModule] = useState('');
  const [carryOverTags, setCarryOverTags] = useState('');

  const handleOpenContactExist = () => {
    setContactExist(true);
  };

  const handleCloseContactExist = () => {
    setContactExist(false);
  };

  const handleOpenAccountExist = () => {
    setAccountExist(true);
  };

  const handleCloseAccountExist = () => {
    setAccountExist(false);
  };

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const handleChangeForm = (e) => {
    const { name, value } = e.target;

    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    let processedValue = value;

    if (name === 'expectedRevenue') {
      processedValue = value.trim() === '' ? null : parseFloat(value);
    }

    if (name === 'description') {
      setEditedDescription(value);
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: processedValue,
      }));
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
    } else if (name === 'stageId') {
      setFormData({
        ...formData,
        stageId: selectedId,
        stage: selectedValue,
      });
    } else if (name === 'campaignSourceId') {
      setFormData({
        ...formData,
        campaignSourceId: selectedId,
        campaignSource: selectedValue,
      });
    }
  };

  const updateList = (msg) => {
    setLoading(false);
    toast.success(msg, {
      position: 'top-right',
    });
    const columnName = 'UpdatedDateTime';
    const orderType = 'desc';
    const data = {
      pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      pageNumber: 1,
      columnName: columnName,
      orderType: orderType,
      filterJson: null,
    };
    dispatch(fetchDataAndUpdateStore({ key: 'leads', inputData: data }));
    dispatch(fetchDataAndUpdateStore({ key: 'contactList', inputData: data }));
    dispatch(fetchDataAndUpdateStore({ key: 'accountList', inputData: data }));
    dispatch(fetchDataAndUpdateStore({ key: 'opportunityList', inputData: data }));
    dispatch(
      fetchDataAndUpdateStore({
        key: 'leadDropdown',
        inputData: dropdownPayload,
      })
    );
    dispatch(
      fetchDataAndUpdateStore({
        key: 'contactDropdown',
        inputData: dropdownPayload,
      })
    );
    dispatch(
      fetchDataAndUpdateStore({
        key: 'accountDropdown',
        inputData: dropdownPayload,
      })
    );
    dispatch(
      fetchDataAndUpdateStore({
        key: 'opportunityDropdown',
        inputData: dropdownPayload,
      })
    );
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    const tagIds = formData?.tags?.map((tag) => tag.id).join(',');
    const additionalData = {
      leadId: formData?.id,
      isCreateOpportunity: formData?.isCreateOpportunity || false,
      isContact: false,
      attachmentModule: attachmentModule ? attachmentModule : '', // Assuming this is always "Lead"
      notifyRecordOwner: formData?.notifyRecordOwner || false,
      notifyLeadOwner: formData?.notifyLeadOwner || false,
      account: {
        ownerId: formData?.ownerId || '',
        associatedUserId: formData?.associatedUserId || '',
        leadId: formData?.id,
        parentAccountId: formData.parentAccountId || '',
        customFields: formData?.customFields || [],
        id: formData?.id || '',
        name: formData?.companyName || '',
        displayName: formData?.displayName || '',
        shortName: formData?.shortName || '',
        description: formData?.description || '',
        industryId: formData?.industryId || '',
        industryType: formData?.industryType || '',
        owner: formData?.owner || '',
        phone: formData?.phone || '',
        alternatePhone: formData?.alternatePhone || '',
        city: formData?.city || '',
        state: formData?.state || '',
        zipCode: formData?.zipCode || '',
        country: formData?.country || '',
        companyLinkedIn: formData?.companyLinkedIn || '',
        website: formData?.website || '',
        employees: formData?.noOfEmployees || null,
        annualRevenue: formData?.annualRevenue || null,
        noOfBeds: formData?.noOfBeds || '',
        street: formData?.street || '',
        technologyDetails: formData?.technologyDetails || '',
      },
      contact: {
        ownerId: formData?.ownerId || '',
        associatedUserId: formData?.associatedUserId || '',
        contactPersonRole: formData?.contactPersonRole || '',
        customFields: formData?.customFields || [],
        id: formData?.id || '',
        name: formData?.fullName || '',
        displayName: formData?.displayName || '',
        shortName: formData?.shortName || '',
        owner: formData?.owner || '',
        description: formData?.description || '',
        leadSourceId: formData?.leadSourceId || '',
        leadSourceType: formData?.leadSourceType || '',
        firstName: formData?.firstName || '',
        middleName: formData?.middleName || '',
        lastName: formData?.lastName || '',
        title: formData?.title || '',
        email: formData?.email || '',
        secondaryEmail: formData?.secondaryEmail || '',
        department: formData?.department || '',
        accountId: formData?.accountId || '',
        salutation: formData?.salutation || '',
        salutationId: formData?.salutationId || '',
        tags: [tagIds] || [],
        account: formData?.companyName || '',
        phone: formData?.phone || '',
        mobile: formData?.mobile || '',
        reportingTo: formData?.reportingTo || '',
        assistant: formData?.assistant || '',
        assistantPhone: formData?.assistantPhone || '',
        emailOptOut: formData?.emailOptOut || false,
        linkedin: formData?.contactLinkedIn || '',
        twitter: formData?.twitter || '',
        facebook: formData?.facebook || '',
        skypeId: formData?.skypeId || '',
        street: formData?.street || '',
        city: formData?.city || '',
        state: formData?.state || '',
        zipCode: formData?.zipCode || '',
        country: formData?.country || '',
        technologyStack: formData?.technologyDetails || '',
      },
      ...(formData?.isCreateOpportunity && {
        opportunity: {
          ownerId: formData?.ownerId || '',
          associatedUserId: formData?.associatedUserId || '',
          customFields: formData?.customFields || [],
          id: formData?.id || '',
          name: formData?.name || '',
          accountId: formData?.accountId || '',
          accountName: formData?.accountName || '',
          contactId: formData?.contactId || '',
          contactName: formData?.contactName || '',
          projectTypeId: formData?.projectTypeId || '',
          projectType: formData?.projectType || '',
          nextStep: formData?.nextStep || '',
          forecastCategoryId: formData?.forecastCategoryId || '',
          forecastCategory: formData?.forecastCategory || '',
          amount: formData?.amount || null,
          stageId: formData?.stageId || '',
          stage: formData?.stage || '',
          probability: formData?.probability || null,
          closingDate: formData?.closingDate || null,
          expectedRevenue: formData?.expectedRevenue || null,
          campaignSource: formData?.campaignSource || '',
          campaignSourceId: formData?.campaignSourceId || '',
          reachOutForMarketing: formData?.reachOutForMarketing || null,
          description: editedDescription || '',
          technologyStack: formData?.technologyDetails || '',
          owner: formData?.owner || '',
          industryId: formData?.industryId || '',
          industry: formData?.industry || '',
          businessType: formData?.businessType || '',
          leadSourceId: formData?.leadSourceId || '',
          leadSource: formData?.leadSource || '',
          sourceName: formData?.sourceName || '',
          lineOfBusiness: formData?.lineOfBusiness || '',
          otherSourceName: formData?.otherSourceName || '',
        },
      }),
    };

    if (formData.isCreateOpportunity) {
      try {
        await validationSchemaDeal.validate(additionalData.opportunity, {
          abortEarly: false,
        });
      } catch (error) {
        if (error.name === 'ValidationError') {
          error.errors.forEach((msg) => {
            toast.error(msg, { position: 'top-right' });
          });
          setLoading(false);
          return;
        }
      }
    }
    apiServices
      .convertLead(additionalData)
      .then((response) => {
        if (response.status === 200) {
          if (response.data === 'Contact already exist') {
            handleOpenContactExist();
            setLoading(false);
          } else if (response.data === 'Account already exist') {
            handleOpenAccountExist();
            setLoading(false);
          } else {
            updateList('Form submitted successfully!');
            onSuccess();
          }
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleConfirmOverwrite = (formData, isContactExist = false, isAccountExist = false) => {
    setLoading(true);
    const tagIds = formData?.tags?.map((tag) => tag.id).join(',');
    const additionalData = {
      leadId: formData?.id,
      isCreateOpportunity: formData?.isCreateOpportunity,
      isContact: isContactExist,
      isAccount: isAccountExist,
      attachmentModule: attachmentModule ? attachmentModule : '', // Assuming this is always "Lead"
      notifyRecordOwner: formData?.notifyRecordOwner,
      notifyLeadOwner: formData?.notifyLeadOwner,
      account: {
        ownerId: formData?.ownerId || '',
        associatedUserId: formData?.associatedUserId || '',
        customFields: formData?.customFields || [],
        id: formData?.id || '',
        name: formData?.companyName || '',
        displayName: formData?.displayName || '',
        shortName: formData?.shortName || '',
        description: formData?.description || '',
        industryId: formData?.industryId || '',
        industryType: formData?.industryType || '',
        owner: formData?.owner || '',
        phone: formData?.phone || '',
        alternatePhone: formData?.alternatePhone || '',
        city: formData?.city || '',
        state: formData?.state || '',
        zipCode: formData?.zipCode || '',
        country: formData?.country || '',
        companyLinkedIn: formData?.companyLinkedIn || '',
        website: formData?.website || '',
        employees: formData?.noOfEmployees || null,
        annualRevenue: formData?.annualRevenue || null,
        noOfBeds: formData?.noOfBeds || '',
        street: formData?.street || '',
        technologyDetails: formData?.technologyDetails || '',
      },
      contact: {
        ownerId: formData?.ownerId || '',
        associatedUserId: formData?.associatedUserId || '',
        customFields: formData?.customFields || [],
        id: formData?.id || '',
        name: formData?.companyName || '',
        displayName: formData?.displayName || '',
        shortName: formData?.shortName || '',
        owner: formData?.owner || '',
        description: formData?.description || '',
        leadSourceId: formData?.leadSourceId || '',
        leadSourceType: formData?.leadSourceType || '',
        firstName: formData?.firstName || '',
        middleName: formData?.middleName || '',
        lastName: formData?.lastName || '',
        title: formData?.title || '',
        email: formData?.email || '',
        secondaryEmail: formData?.secondaryEmail || '',
        department: formData?.department || '',
        accountId: formData?.accountId || '',
        salutation: formData?.salutation || '',
        salutationId: formData?.salutationId || '',
        tags: [tagIds] || [],
        account: formData?.companyName || '',
        phone: formData?.phone || '',
        mobile: formData?.mobile || '',
        reportingTo: formData?.reportingTo || '',
        assistant: formData?.assistant || '',
        assistantPhone: formData?.assistantPhone || '',
        emailOptOut: formData?.emailOptOut || false,
        contactPersonRole: formData?.contactPersonRole || '',
        linkedin: formData?.companyLinkedIn || '',
        twitter: formData?.twitter || '',
        facebook: formData?.facebook || '',
        skypeId: formData?.skypeId || '',
        street: formData?.street || '',
        city: formData?.city || '',
        state: formData?.state || '',
        zipCode: formData?.zipCode || '',
        country: formData?.country || '',
        technologyStack: formData?.technologyDetails || '',
      },
      ...(formData?.isCreateOpportunity && {
        opportunity: {
          ownerId: formData?.ownerId || '',
          associatedUserId: formData?.associatedUserId || '',
          customFields: formData?.customFields || [],
          id: formData?.id || '',
          name: formData?.name || '',
          accountId: formData?.accountId || '',
          accountName: formData?.accountName || '',
          contactId: formData?.contactId || '',
          contactName: formData?.contactName || '',
          projectTypeId: formData?.projectTypeId || '',
          projectType: formData?.projectType || '',
          nextStep: formData?.nextStep || '',
          forecastCategoryId: formData?.forecastCategoryId || '',
          forecastCategory: formData?.forecastCategory || '',
          amount: formData?.amount || null,
          stageId: formData?.stageId || '',
          stage: formData?.stage || '',
          probability: formData?.probability || null,
          closingDate: formData?.closingDate || null,
          expectedRevenue: formData?.expectedRevenue || null,
          campaignSource: formData?.campaignSource || '',
          reachOutForMarketing: formData?.reachOutForMarketing || false,
          description: editedDescription || '',
          technologyStack: formData?.technologyDetails || '',
          owner: formData?.owner || '',
          industryId: formData?.industryId || '',
          industry: formData?.industry || '',
          businessType: formData?.businessType || '',
          leadSourceId: formData?.leadSourceId || '',
          leadSource: formData?.leadSource || '',
          sourceName: formData?.sourceName || '',
          lineOfBusiness: formData?.lineOfBusiness || '',
          otherSourceName: formData?.otherSourceName || '',
        },
      }),
    };

    apiServices
      .convertLead(additionalData)
      .then((response) => {
        if (response.status === 200) {
          handleCloseContactExist();
          if (response.data === 'Account already exist') {
            handleOpenAccountExist();
            setLoading(false);
          } else {
            handleCloseAccountExist();
            updateList('Form submitted successfully!');
            onSuccess();
          }
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };
  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set the checkbox state as true/false
    }));
    if (name === 'isCreateOpportunity') {
      setIsCheckBox(!isCheckBox); // Toggle the isCheckBox state
    }
  };

  const handleAttachmentChange = (e) => {
    setAttachmentModule(e.target.value);
  };

  const handleTagsChange = (e) => {
    setCarryOverTags(e.target.value);
  };

  const onSuccess = () => {
    navigate('/leads/convertLead=Success', { state: formData });
  };

  const gotoLeads = () => {
    navigate('/leads');
  };

  useEffect(() => {
    if (location.pathname.includes('convertLead') && location.state) {
      let updatedFormData = {
        ...location.state,
        name: location.state.companyName,
        type: 'convert',
      };
      setFormData(updatedFormData);
    }
  }, [location]);

  return (
    <>
      <div className="convert_container" id="convertlead">
        <Formik
          initialValues={formData}
          onSubmit={(values) => handleSubmit(values)}
          validationSchema={validationSchemaDeal}
        >
          <Form>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-3">
                <div className="input-container">
                  <TextBox
                    label={'Account'}
                    name={'country'}
                    value={formData?.companyName}
                    placeholder={'Rangoni Of Florence'}
                    maxLength={250}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-3">
                <div className="input-container">
                  <TextBox
                    label={'Create New Contact '}
                    name={'country'}
                    value={`${formData?.firstName ?? ''} ${formData?.middleName ?? ''} ${formData?.lastName ?? ''}`}
                    placeholder={'Christopher Maclead (Sample)'}
                    maxLength={250}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <hr />
              </div>
              <div className="col-12 col-md-12" id="flex-clumn">
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    name="isCreateOpportunity"
                    className="checkbox-input"
                    onChange={handleChangeCheckbox}
                  />
                  <label htmlFor="isCreateOpportunity" className="checkbox-label">
                    Create a new Opportunity for this Account.
                  </label>
                </div>
              </div>
              {isCheckBox && (
                <>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <NumberBox
                        fieldClass={'dollarValue'}
                        label={'Expected Revenue'}
                        name={'expectedRevenue'}
                        placeholder={'Enter Expected Revenue'}
                        value={formData?.expectedRevenue ?? ''}
                        handleChange={handleChangeForm}
                        maxLength={250}
                        errormsg={errormsg?.expectedRevenue}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <TextBox
                        label={'Opportunity Name'}
                        name={'name'}
                        placeholder={'Enter Opportunity Name'}
                        value={formData?.name}
                        handleChange={handleChangeForm}
                        errormsg={errormsg?.companyName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <TextBox
                        label={'Next Step'}
                        name={'nextStep'}
                        isRequired={true}
                        placeholder={'Enter Next Step'}
                        value={formData?.nextStep}
                        handleChange={handleChangeForm}
                        errormsg={errormsg?.nextStep}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <TextBox
                        label={'Source Name'}
                        name={'sourceName'}
                        placeholder={'Enter Source Name'}
                        value={formData?.sourceName}
                        handleChange={handleChangeForm}
                        errormsg={errormsg?.sourceName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3" id="date">
                    <div className="input-container">
                      <DateBox
                        label={'Closing Date'}
                        name={'closingDate'}
                        value={formData.closingDate}
                        errormsg={errormsg.closingDate}
                        handleChange={handleChangeForm}
                        minDate={new Date()}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <SelectBox
                        label={'Stage'}
                        name={'stageId'}
                        placeholder={formData?.stage || 'Select Stage'}
                        isRequired={true}
                        disabled={formData?.type === 'view'}
                        selectedOptions={selectedOptions.stageId}
                        handleSelect={handleChange}
                        options={stage}
                        optionKeys={['id', 'displayName']}
                        errormsg={errormsg?.stageId}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <SelectBox
                        label={'Campaign Source'}
                        name={'campaignSourceId'}
                        placeholder={formData?.campaignSource || 'Select Campaign Source'}
                        selectedOptions={selectedOptions.campaignSourceId}
                        handleSelect={handleChange}
                        options={campaignSource}
                        optionKeys={['id', 'campaignName']}
                        errormsg={errormsg?.campaignSourceId}
                        isLoading={isCampaignLoading}
                        onScrollToBottom={handleCampaignScroll}
                        onSearch={handleCampaignSearch}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <SelectBox
                        label={'Industry'}
                        name={'industryId'}
                        placeholder={formData?.industry || 'Select Industry'}
                        isRequired={true}
                        disabled={formData?.type === 'view'}
                        selectedOptions={selectedOptions.industryId}
                        handleSelect={handleChange}
                        options={industryTypeDropdown}
                        optionKeys={['id', 'displayName']}
                        errormsg={errormsg?.industryId}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <SelectBox
                        label={'Lead Source'}
                        name={'leadSourceId'}
                        placeholder={formData?.leadSource || 'Select Lead Source'}
                        isRequired={true}
                        disabled={formData?.type === 'view'}
                        selectedOptions={selectedOptions.leadSourceId}
                        handleSelect={handleChange}
                        options={leadSourceDropdown}
                        optionKeys={['id', 'displayName']}
                        errormsg={errormsg?.leadSourceId}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <div className="input-container">
                      <TextArea
                        label={'Description'}
                        name={'description'}
                        placeholder={'Enter Description'}
                        value={editedDescription}
                        handleChange={handleChangeForm}
                        errormsg={errormsg?.description}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="col-12 col-md-12">
                <div className="input-container radio_flx">
                  <label htmlFor="optionsGroup">
                    {'Where would you like to move the attachments to? (If any)'}
                  </label>

                  <div id="optionsGroup">
                    {/* Radio button 1 */}
                    <div>
                      <label>
                        <input
                          type="radio"
                          id="option1"
                          name="attachmentModuleContact"
                          value="Contact"
                          onChange={handleAttachmentChange}
                          checked={attachmentModule === 'Contact'}
                        />
                        Contact
                      </label>
                    </div>

                    {/* Radio button 2 */}
                    <div>
                      <label>
                        <input
                          type="radio"
                          id="option2"
                          name="attachmentModuleAccount"
                          value="Account"
                          onChange={handleAttachmentChange}
                          checked={attachmentModule === 'Account'}
                        />
                        Account
                      </label>
                    </div>

                    {/* Radio button 3 */}

                    <div>
                      <label>
                        <input
                          type="radio"
                          id="option3"
                          name="attachmentModuleOpportunity"
                          value="Opportunity"
                          onChange={handleAttachmentChange}
                          checked={attachmentModule === 'Opportunity'}
                          disabled={!formData?.isCreateOpportunity}
                        />
                        Opportunity
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {formData?.tagIds?.length > 0 && (
                <div className="col-12 col-md-12">
                  <div className="input-container radio_flx">
                    <label htmlFor="optionsGroup">Carry over Tags to :</label>

                    <div id="optionsGroup">
                      {/* Radio button 1 */}
                      <div>
                        <label>
                          <input
                            type="radio"
                            id="option1"
                            name="carryOverTagsContact"
                            value="Contact"
                            onChange={handleTagsChange}
                            checked={carryOverTags === 'Contact'}
                          />
                          Contact
                        </label>
                      </div>

                      {/* Radio button 2 */}
                      <div>
                        <label>
                          <input
                            type="radio"
                            id="option2"
                            name="carryOverTagsAccount"
                            value="Account"
                            onChange={handleTagsChange}
                            checked={carryOverTags === 'Account'}
                          />
                          Account
                        </label>
                      </div>

                      {/* Radio button 3 */}
                      <div>
                        <label>
                          <input
                            type="radio"
                            id="option3"
                            name="carryOverTagsOpportunity"
                            value="Opportunity"
                            onChange={handleTagsChange}
                            checked={carryOverTags === 'Opportunity'}
                          />
                          Opportunity
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-12 col-md-3" id="ownermodal">
                <div className="input-container">
                  <label htmlFor="timeZoneId">Owner of the New Records</label>
                  <Select
                    value={selectedOptions?.ownerId || formData?.owner}
                    onChange={(selectedOption) => handleChange(selectedOption, 'ownerId')}
                    options={owner?.map((data) => ({
                      value: data.userId,
                      label: data.display_name,
                    }))}
                    menuShouldScrollIntoView={false}
                    placeholder={formData?.owner || 'Select Contact Owner'}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderRadius: '5px',
                        borderColor: state.isFocused ? '#3498db' : '#ccc',
                        borderWidth: state.isFocused ? '1px' : '1px',
                        paddingRight: '30px',
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: '0',
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '10px',
                      }),
                      indicatorSeparator: () => ({
                        display: 'none',
                      }),
                      menu: (base) => ({
                        ...base,
                        borderRadius: '5px',
                        zIndex: 99999,
                      }),
                    }}
                    components={{
                      DropdownIndicator: (props) => (
                        <div
                          {...props.innerProps}
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          {/* Custom SVG icon */}
                          <svg
                            width="18"
                            height="20"
                            viewBox="0 0 18 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.3334 18.25V16.4167C16.3334 15.4442 15.9471 14.5116 15.2595 13.8239C14.5718 13.1363 13.6392 12.75 12.6667 12.75H5.33341C4.36095 12.75 3.42832 13.1363 2.74069 13.8239C2.05306 14.5116 1.66675 15.4442 1.66675 16.4167V18.25M12.6667 5.41667C12.6667 7.44171 11.0251 9.08333 9.00008 9.08333C6.97504 9.08333 5.33341 7.44171 5.33341 5.41667C5.33341 3.39162 6.97504 1.75 9.00008 1.75C11.0251 1.75 12.6667 3.39162 12.6667 5.41667Z"
                              stroke="#9B9B9B"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      ),
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-12">
                <div className="input-container">
                  <div className="convert_group">
                    <button type="button" className="btn btn-outline-primary" onClick={gotoLeads}>
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => handleSubmit(formData)}
                    >
                      {loading && (
                        <>
                          {' '}
                          <div
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></div>
                        </>
                      )}
                      {loading ? 'Loading...' : 'Convert'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
      {contactExist && (
        <Modal show={contactExist} onHide={handleCloseContactExist} className="modal-delete">
          <Modal.Header closeButton>
            <Modal.Title>Warning!</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            This Contact Already Exists!
            <br />
            Do you want to overwrite this contact ?
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleCloseContactExist}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleConfirmOverwrite(formData, true, false)}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}

      {accountExist && (
        <Modal show={accountExist} onHide={handleCloseAccountExist} className="modal-delete">
          <div className="warning-content">
            <div className="alertImg">
              <img src="../assets/images/alert.png" alt="Warning"></img>
            </div>
            <div className="warningText">
              <h2>This Account Already Exists!</h2>

              <p>Do you want to overwrite this account ?</p>
            </div>
            <div className="warningBtn">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                onClick={handleCloseAccountExist}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleConfirmOverwrite(formData, true, true)}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ConvertLead;
